import clsx from 'clsx';

import { Button } from '@tock/shared/components/buttons/DeprecatedButton';
import { Typography } from 'omakase';
import { useHistory } from 'react-router';

interface Props {
  viewingTab: 'overview' | 'reservations' | 'saved';
}

const ProfileHeaderNavigation = ({ viewingTab }: Props) => {
  const navLinkClassname = 'Profile-navigationLink';
  const navLinkWrapperClassname = 'Profile-navigationLinkWrapper';
  const history = useHistory();

  const onClickOverview = () => {
    const overviewPath = '/profile';
    history.location.pathname !== overviewPath && history.push(overviewPath);
  };

  const onClickReservations = () => {
    const reservationsPath = '/profile/reservations';
    history.location.pathname !== reservationsPath && history.push(reservationsPath);
  };

  const onClickPlaylists = () => {
    const playlistsPath = '/profile/saved';
    history.location.pathname !== playlistsPath && history.push(playlistsPath);
  };

  return (
    <div>
      <Button
        variant="borderless"
        modifierClassName={navLinkClassname}
        onClick={onClickOverview}
        onKeyPress={onClickOverview}
      >
        <div
          className={clsx(navLinkWrapperClassname, { 'is-selected': viewingTab === 'overview' })}
        >
          <Typography color="inherit" component="span" variant="body02Strong">
            Overview
          </Typography>
        </div>
      </Button>
      <Button
        variant="borderless"
        modifierClassName={navLinkClassname}
        onClick={onClickReservations}
        onKeyPress={onClickReservations}
      >
        <div
          className={clsx(navLinkWrapperClassname, {
            'is-selected': viewingTab === 'reservations',
          })}
        >
          <Typography color="inherit" component="span" variant="body02Strong">
            Reservations
          </Typography>
        </div>
      </Button>
      <Button
        variant="borderless"
        modifierClassName={navLinkClassname}
        onClick={onClickPlaylists}
        onKeyPress={onClickPlaylists}
      >
        <div className={clsx(navLinkWrapperClassname, { 'is-selected': viewingTab === 'saved' })}>
          <Typography color="inherit" component="span" variant="body02Strong">
            Saved
          </Typography>
        </div>
      </Button>
    </div>
  );
};

export default ProfileHeaderNavigation;
